import React from 'react'
import CollapseAction from './actions/CollapseAction';
import ExpandAction from './actions/ExpandAction';
import DateFilterAction from './actions/DateFilterAction';
import OrderTypeFilterAction from './actions/OrderTypeFilterAction';
import ClearFiltersAction from './actions/ClearFiltersAction';

type Props = {
  moduleRefetch: () => {},
  ColumnsAction: {},
  changeDisplayMenu: () => {},
  displayMenu: Boolean,
  monthSelector: any,
  stateSelector: any,
  groups: [],
  grid: { rows: [], selection: { row: {} } },
  getGlobalDisabledState: () => {},
  loading: Boolean,
  showCollapse: Boolean,
  onGroupCollapsedChanged: Boolean,
  currentItem: {},
  showDateFilterDropdown: Boolean,
  showOrderTypeFilterDropdown: Boolean,
  filters: [],
  isRep: Boolean,
  saveStatus: Boolean,
  onFiltersChanged: () => {},
  moduleName: String,
  menuButtonRef: any,
  clearInternalFilters: () => {},
}

const ModuleMenuBar = (props: Props) => {
  const {
    moduleRefetch,
    ColumnsAction,
    changeDisplayMenu,
    displayMenu,
    stateSelector,
    monthSelector,
    loading,
    groups,
    grid,
    getGlobalDisabledState,
    showCollapse,
    onGroupCollapsedChanged,
    currentItem,
    showDateFilterDropdown,
    showOrderTypeFilterDropdown,
    filters,
    saveStatus,
    onFiltersChanged,
    moduleName,
    menuButtonRef,
    clearInternalFilters,
  } = props;

  let columnGroupActionsDisabled = null;
  let allowExpandAction = null;
  if (showCollapse && getGlobalDisabledState) {
    columnGroupActionsDisabled =
      getGlobalDisabledState() || loading || (groups && !groups.length);

    allowExpandAction =
      !grid ||
      (grid.selection.row >= 0 && grid.rows[grid.selection.row].isCollapsed) ||
      (grid.selection.row < 0 && grid.rows.some(row => row.isCollapsed));
  }

  return (
    <div className='module-menu-bar'>
      <div style={{ display: 'flex' }}>
        <img style={{ marginLeft: 10 }} src='assets/refresh_black.svg' onClick={moduleRefetch} alt='refresh icon' />
        {ColumnsAction && <ColumnsAction />}
        {clearInternalFilters && <ClearFiltersAction
          clearInternalFilters={clearInternalFilters}
          disabled={loading}
        />}
        {stateSelector}
        {monthSelector}
        {showCollapse && (columnGroupActionsDisabled || !allowExpandAction) &&
          <CollapseAction
            disabled={loading || allowExpandAction}
            grid={grid}
            onGroupCollapsedChanged={onGroupCollapsedChanged}
            currentItem={currentItem}
          />
        }
        {showCollapse && !loading && allowExpandAction &&
          <ExpandAction
            disabled={columnGroupActionsDisabled || !allowExpandAction}
            onGroupCollapsedChanged={onGroupCollapsedChanged}
            grid={grid}
          />
        }
        {showDateFilterDropdown &&
          <div style={{ display: 'flex', marginLeft: 5 }}>
            <DateFilterAction
              disabled={loading}
              onClick={onFiltersChanged}
              filters={filters}
              filterType="Date"
              saveStatus={saveStatus}
              moduleName={moduleName}
            />
          </div>
        }
        {showOrderTypeFilterDropdown &&
          <OrderTypeFilterAction
            disabled={loading}
            onClick={onFiltersChanged}
            filters={filters}
            filterType="OrderType"
            saveStatus={saveStatus}
          />
        }
      </div>
      {changeDisplayMenu &&
        <div>
          <img
            ref={menuButtonRef}
            src='assets/3dots.svg'
            onClick={() => {
              changeDisplayMenu(!displayMenu)
            }}
            alt='display menu icon'
          />
        </div>
      }

    </div>
  )
};

export default ModuleMenuBar;